import {
  componentNameConstants,
  dlEventConstants,
} from "@repo/analytics/data-layer.constants";
import { dataLayer } from "@repo/analytics/data-layer-utils";

/**
 * FooterAccordionFunction.ts
 * Analytics handler for Footer Accordion button clicks and link clicks
 */

// Define constants for footer events
const FOOTER_ACCORDION_TOGGLE = "footer_accordion_toggle";
const FOOTER_LINK_CLICK = "FOOTER_LINK_CLICK";
const FOOTER_COMPONENT_NAME = "footer";
const FOOTER_NAVIGATION_LINK = "footer_navigation_link";
const FOOTER_CLICK_TYPE = "footer_click";

// Analytics event handler for Footer Accordion click
export function handleFooterAccordionClickDL(
  loginStatus: string,
  title: string,
  cta_text: string,
) {
  // Create analytics data object
  const data = {
    component: componentNameConstants.FOOTER_COMPONENT,
    event: dlEventConstants.CLICK,
    event_type: dlEventConstants.BUTTON_CLICK,
    element: FOOTER_ACCORDION_TOGGLE,
    cta_text: cta_text || "",
    sec_title: title,
  };

  const cleverTapObj = {
    component: data.component,
    event: data.event,
    event_type: data.event_type,
    element: data.element,
    cta_text: data.cta_text,
    sec_title: data.sec_title,
  };

  dataLayer(loginStatus, data, cleverTapObj);
}

/**
 * Analytics handler for footer link clicks
 * Tracks clicks on links within the footer accordion sections
 */
export function handleFooterLinkClickDL(
  cta_text: string,
  sec_title: string,
  destination_url: string,
) {
  // Create analytics data object
  const data = {
    event: dlEventConstants.CLICK,
    event_type: FOOTER_CLICK_TYPE,
    destination_url: destination_url,
    component: FOOTER_COMPONENT_NAME,
    element: FOOTER_NAVIGATION_LINK,
    cta_text: cta_text,
    sec_title: sec_title,
  };

  const cleverTapObj = {
    event: data.event,
    event_type: data.event_type,
    destination_url: data.destination_url,
    component: data.component,
    element: data.element,
    cta_text: data.cta_text,
    sec_title: data.sec_title,
  };

  dataLayer("", data, cleverTapObj);
}
